// 권한 판단 유틸 (spec R-FE-02). 화면은 이 파일의 checker를 직접 쓰지 않고 useAccess().hasPermission(key)를 쓴다.

/** 권한 키 목록 → hasPermission(key) 함수 */
export function createPermissionChecker(permissions) {
  const granted = new Set(Array.isArray(permissions) ? permissions : []);
  return (key) => typeof key === "string" && granted.has(key);
}

/**
 * /me 실패 시에만 쓰는 임시 대체표 — legacy role 기준 (spec D-13, R-MIG-01 시드와 같은 결과).
 *
 * API(GET /admin/access/me, Catachrank-API PR #412)가 아직 배포되지 않은 환경에서 FE가 먼저 나가도
 * 메뉴가 전부 사라지지 않게 한다. 화면 권한은 시드의 legacy_* 역할 defaultRoles(spec 5.4.2)와 같고,
 * 9개 기능 버튼 키는 기존 FE처럼 화면 접근자에게 보인다(실행 여부는 API의 WalletRoleGuard·enforceAlways가 막는다).
 * 매출분석(revenue_analyst)은 이메일 목록을 FE에서 없앴으므로 대체 모드에서는 보이지 않는다.
 * TODO(AMP-2561): API가 prod에 배포되고 /me가 안정화되면 이 대체표를 제거한다.
 */
const SCREEN = {
  owner: [
    "dashboard.read",
    "blog_analysis.registry.read",
    "account.password.update",
    "member.read",
    "member.create",
    "reward.read",
    "ad.reception.read",
    "reward_admin.read",
    "ad.settings.read",
    "ad.invoice.read",
    "wallet.read",
    "ad.settlement.read",
  ],
  marketer: [
    "dashboard.read",
    "blog_analysis.registry.read",
    "account.password.update",
    "ad.reception.read",
    "reward_admin.read",
    "ad.settings.read",
    "ad.settlement.read",
  ],
  fe: ["blog_analysis.registry.read", "account.password.update", "ad.reception.read"],
  partner: ["ad.settlement.read"],
};

const WALLET_SCREEN_ACTIONS = [
  "wallet.withdrawal.approve",
  "wallet.withdrawal.reject",
  "wallet.withdrawal.complete",
  "wallet.payment.cancel",
  "wallet.policy.update",
  "wallet.user_charge.execute",
  "wallet.user_risk_flag.update",
];
const AD_RECEPTION_ACTIONS = ["ad.campaign.refund", "ad.review_delete.refund"];

export const LEGACY_FALLBACK_PERMISSIONS = {
  owner: [...SCREEN.owner, ...WALLET_SCREEN_ACTIONS, ...AD_RECEPTION_ACTIONS],
  marketer: [...SCREEN.marketer, ...AD_RECEPTION_ACTIONS],
  fe: [...SCREEN.fe, ...AD_RECEPTION_ACTIONS],
  partner: [...SCREEN.partner],
};

/** legacy role → 대체 권한 목록. role이 없거나 모르는 값이면 legacy_marketer(시드 규칙: role NULL → legacy_marketer). */
export function legacyFallbackPermissions(legacyRole) {
  return LEGACY_FALLBACK_PERMISSIONS[legacyRole] ?? LEGACY_FALLBACK_PERMISSIONS.marketer;
}
